import { createTheme } from "@material-ui/core/styles"
import { primaryColor, secondaryColor, lightGrey } from "./GlobalStyle"

export const Theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: primaryColor
        },
        secondary: {
            main: secondaryColor
        },
        clear: {
            main: lightGrey
        },
        text: {
            primary: lightGrey
        }
    }
})